type AnalyticsConfig = {
    amplitude: {
        apiKey: string;
        apiEndpoint: string;
    };
};

const stage = window.REACT_APP_NODE_ENV;

let config: AnalyticsConfig;
switch (stage) {
    case 'production':
        config = {
            amplitude: {
                apiKey: 'b84c4253587a4aad352a9bb42f74d156',
                apiEndpoint: 'usage.helloself.com',
            },
        };
        break;
    case 'staging':
        config = {
            amplitude: {
                apiKey: '3464f3697c8f4177bae4950c3d7585a5',
                apiEndpoint: 'usage.test-helloself.com',
            },
        };
        break;
    case 'local':
    case 'test':
    case 'development':
    default:
        config = {
            amplitude: {
                apiKey: '598e0b769cc0267fd815d18461c61254',
                apiEndpoint: 'usage.dev-helloself.com',
            },
        };
}

export default config;
